export default {
    Auth: {},
    loaddingLogin: false,
    usernameLog: ''
}